import React from "react";
import CalendlyButton from "../components/CalendlyButton";
import ProfileCard from "../components/ProfileCard";

const WhoWeAreSection = () => {
  return (
    <section className="bg-[#f9f9f9] pt-12 pb-8 px-4 md:px-8">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center lg:items-start gap-10 text-center lg:text-left">
        
        {/* Image + Name Block */}
        <ProfileCard
          image="/amit-vishnoi.png"
          name="Amit Vishnoi"
          title="Director & Buyer's Agent"
        />

        {/* Content */}
        <div className="w-full flex-1">
          <h2 className="text-3xl font-bold text-[#003366] mb-4">Who We Are</h2>
          <p className="text-lg text-[#003366] mb-4">
            At <strong>National Property Consultant</strong>, we’re more than just buyer’s agents — we’re partners in your investment journey.
          </p>
          <p className="text-md text-gray-700 mb-6">
            Led by <strong>Amit Vishnoi</strong>, we help busy professionals, first-time investors, and SMSF buyers build high-performing portfolios with off-market access, due diligence, and total transparency.
          </p>
          <ul className="list-disc pl-5 text-gray-700 space-y-2 mb-6 text-left lg:text-left mx-auto lg:mx-0 max-w-md lg:max-w-none">
            <li>Strategic planning tailored to your goals</li>
            <li>Off-market and high-yield sourcing</li>
            <li>End-to-end support from inspection to settlement</li>
            <li>Backed by data, delivered with integrity</li>
          </ul>
          <CalendlyButton label="Book Free Consultation" />
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;
